export const getters = {
  getWidget: (state) => state.widget
};
